import { 
  produto,
  pedidos,
  SearchProduto,
  gift,
  searchprodutopainel,
  searchclientpainel,
  searchpedidopainel,
  searchuserpainel,
  searchgiftpainel
} from './query'
import FrenteLoja from '@/views/FrenteLoja'
import router from '../../router'
export default {
  GetGift ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: gift,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        commit('GET_GIFT', { payload: res.data.data.GetGift, init: payload.init })
        resolve()
      })
    })
  },
  SearchNameProd (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: SearchProduto,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.SearchNameProd)
      })
    })
  },
  GetCategory ({ commit }) {
    return new Promise((resolve) => {
      this.$http({
        params: {
          query: `
          {
            GetCategory {
              id,
              active,
              name,
              icon,
              link
            }
          }
          `
        }
      })
      .then(res => {
        commit('GET_CATEGORY', res.data.data.GetCategory)
        resolve()
      })
    })
  },
  PushClientPainel ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: icliente) {
            _CreateClient (payload: $payload) {
              id
            }
          }
        `,
        variables: {
          payload: {
            usuario: payload.usuario,
            endereco: payload.endereco
          }
        }
      })
      .then(() => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: 'Cliente cadastrado com sucesso', color: 'green' })
        resolve()
      })
    })
  },
  GetPedidos ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: pedidos,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        commit('GET_PEDIDOS', { payload: res.data.data.GetPedido, init: payload.init })
        resolve()
      })
    })
  },
  GetProduct ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: produto,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        if (payload.init) {
          commit('GET_PRODUCT_SEARCH', [])
        }
        commit('GET_PRODUCT', res.data.data.GetProdutoPainel)
        resolve()
      })
    })
  },
  GetLibImg ({ commit, dispatch }) {
    return new Promise((resolve) => {
      dispatch('Loding', true)
      this.$http({
        params: {
          query: `
            query {
              GetLibImg {
                id,
                img
              }
            }
          `
        }
      })
      .then(res => {
        dispatch('Loding', false)
        commit('GET_LIB_IMG', res.data.data.GetLibImg)
        resolve()
      })
    })
  },
  SetModal: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_MODAL', payload)
    resolve()
  }),
  PushImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _CreateLibImg (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            img: [{ img: payload.img, filename: payload.filename }]
          }
        }
      })
      .then(res => {
        dispatch('Loading', false)
        if(!res.data.data._CreateLibImg.status) {
          dispatch('PushMsg', { msg: res.data.data._CreateLibImg.message, color: 'red' })
        } else {
          dispatch('GetLibImg')
            .then(() => {
              resolve()
            })
        }
      })
    })
  },
  ChangeProdEdit ({ commit }, payload) {
    commit('CHANGE_PRODEDIT', payload)
  },
  ToFileProd: ({ commit }, payload) => new Promise((resolve) => {
    commit('TOFILE_PROD', payload)
    resolve()
  }),
  ChangeStatusProd ({ commit }, payload) {
    commit('CHANGESTATUS_PROD', payload)
  },
  setProdCateg ({ commit }, payload) {
    commit('SET_PROD_CATEG', payload)
  },
  changeCategEdit ({ commit }, payload) {
    commit('CHANGE_CATEGEDIT', payload)
  },
  _UpdateCategory ({ dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: icategory) {
            _UpdateCategory (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('PushMsg', { msg: res.data.data._UpdateCategory.message, color: 'green' })
        resolve()
      })
    })
  },
  _DeleteCategory ({ dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: icategory) {
            _DeleteCategory (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('GetCategory')
        dispatch('PushMsg', { msg: res.data.data._DeleteCategory.message, color: 'green' })
        resolve()
      })
    })
  },
  PushCateg ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: icategory) {
            _CreateCategory (payload: $payload) {
              id,
              active,
              name,
              icon
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: 'Categoria cadastrada com sucesso', color: 'green' })
        commit('PUSH_CATEG', res.data.data._CreateCategory)
        resolve()
      })
    })
  },
  PushProdEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('PUSH_PRODEDIT', payload)
    resolve()
  }),
  DeleteProdEdit ({ commit }, payload) {
    commit('DELETE_PRODEDIT', payload)
  },
  ClearProdEdit: ({ commit }) => new Promise((resolve) => {
    commit('CLEAR_PRODEDIT')
    resolve()
  }),
  PushAllEdit ({ commit }, payload) {
    commit('PUSH_ALLEDIT', payload)
  },
  UpdatePropProd ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('UPDATE_PROPPROD', payload)
      resolve()
    })
  },
  _UpdateAtr ({ dispatch, getters }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      if(getters.SelectedProdEdit.id !== '') {
        this.$http.post('', {
          query: `
            mutation ($payload: iproduto) {
              _UpdateAtr(payload: $payload) {
                status,
                message
              }
            }
  
          `,
          variables: {
            payload: {
              atributos: [payload]
            }
          }
        })
        .then(res => {
          if(res.data.data._UpdateAtr.status) {
            dispatch('Loading', false)
            
            resolve()
          }
          else {
            dispatch('Loading', false)
            dispatch('PushMsg', { msg: res.data.data._UpdateAtr.message, color: 'red' })
            resolve()
          }
        })
      }
      else {
        dispatch('Loading', false)
        resolve()
      }
    })
  },
  PushPropProd ({ commit, dispatch, getters }, payload) {
    return new Promise((resolve) => {
      let newProp = {
        active: true,
        name: payload.name,
        values: payload.values
      }
      dispatch('Loading', true)
      if(getters.SelectedProdEdit.id !== '') {
        this.$http.post('', {
          query: `
            mutation ($payload: iproduto) {
              _CreateAtr (payload: $payload) {
                active,
                id,
                name,
                values {
                  active,
                  id,
                  name,
                  selected
                }
              }
            }
          `,
          variables: {
            payload: {
              id: payload.prodid,
              atributos: [newProp]
            }
          }
        })
        .then(res => {
          commit('PUSH_PROPPROD', res.data.data._CreateAtr)
          dispatch('Loading', false)
          resolve()
        })
      } else {
        commit('PUSH_PROPPROD', newProp)
        dispatch('Loading', false)
        resolve()       
      }
    })
  },
  _DeleteAtr ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: Int) {
            _DeleteAtr (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        if(res.data.data._DeleteAtr.status) {
          dispatch('Loading', false)
          commit('DELETE_ATR', payload)
          dispatch('PushMsg', { msg: 'Atributo excluído com sucesso.', color: 'green' })
          resolve()
        } else {
          dispatch('Loading', false)
          dispatch('PushMsg', { msg: 'Não foi possível excluir o atributo', color: 'red' })
          resolve()
        }
      })
    })
  },
  UpdateValueProp: ({ commit }, payload) => new Promise((resolve) => {
    commit('UPDATE_VALUEPROP', payload)
    resolve()
  }),
  ChangeGiftEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('CHANGE_GIFT_EDIT', payload)
    resolve()
  }),
  UpdateGift ({ getters, dispatch }) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: igift) {
            _UpdateGift(payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: getters.SelectedGiftEdit
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._UpdateGift.message, color: 'green' })
        resolve()
      })
    })
  },
  PushGift ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      let newGift = {
        codigo: payload.gift.codigo,
        tipo: payload.gift.tipo,
        valor: payload.gift.valor,
        validade: payload.gift.validade === '' ? '01-01-1900' : payload.gift.validade,
        gastoMin: payload.gift.gastoMin,
        gastoMax: payload.gift.gastoMax,
        produtos: payload.produtos,
        produtoDel: payload.produtoDel,
        categorias: payload.categorias,
        categoriasDel: payload.categoriasDel,
        emails: payload.gift.emails,
        limiteCupom: payload.gift.limiteCupom,
        limiteNprodutos: payload.gift.limiteNprodutos,
        limiteUser: payload.gift.limiteUser,
        freteGratis: payload.gift.freteGratis,
        individual: payload.gift.individual,
        itensVendaDel: payload.gift.itensVendaDel
      }
      this.$http.post('', {
        query: `
          mutation ($payload: igift) {
            _CreateGift (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: newGift
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._CreateGift.message, color: 'green' })
        commit('PUSH_GIFT', newGift)
        commit('CLEAR_GIFT_EDIT')
        resolve()
      })
    })
  },
  SetGiftEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_GIFT_EDIT', payload)
    resolve()
  }),
  DeleteGift ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: igift) {
            _DeleteGift (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        commit('DELETE_GIFT', payload)
        resolve()        
      })
    })
  },
  PushEstoqueVariavel ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _CreateStockVar (payload: $payload)
          }
        `,
        variables: {
          payload: {
            id: payload.prodid,
            estoqueVariavel: {
              src: payload.src
            }
          }
        }
      })
      .then(res => {
        dispatch('Loading', false)
        commit('PUSH_ESTOQUE_VARIAVEL', { id: res.data.data._CreateStockVar, src: payload.src })
        resolve()
      })
      //let idVar = payload.src.values.map(v => v.id).reduce((p, c) => p + c)
    })
  },
  UpdateEstoque: ({ commit }, payload) => new Promise((resolve) => {
    commit('UPDATE_ESTOQUE', payload)
    resolve()
  }),
  DeleteEstoqueVariavel ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _DeleteStockVar (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            estoqueVariavel: [payload]
          }
        }
      })
      .then(res => {
        console.log(res)
        if(res.data.data._DeleteStockVar.status) {
          dispatch('Loading', false)
          commit('DELETE_ESTOQUE_VARIAVEL', payload)
          resolve()
        } else {
          dispatch('PushMsg', { msg: res.data.data._DeleteStockVar.message, color: 'rede' })
          dispatch('Loading', false)
          resolve()
        }
      })
    })
  },
  UpdateEstoqueQtde ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _UpdateStockVar (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            estoqueVariavel: [{
              id: payload.id,
              src: {
                quantidade: payload.quantidade
              }
            }]
          }
        }
      })
      .then(res => {
        console.log(res)
        if(res.data.data._UpdateStockVar.status) {
          dispatch('Loading', false)
          commit('UPDATE_ESTOQUE_QTDE', payload)
          resolve()
        }
        else {
          dispatch('PushMsg', { msg: res.data.data._UpdateStockVar.message, cor: 'red' })
          dispatch('Loading', false)
          resolve()
        } 
      })
      
    })
  },
  PushCaracterProd ({ commit, dispatch, getters }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      if(getters.SelectedProdEdit.id !== '') {
        this.$http.post('', {
          query: `
            mutation ($payload: iproduto) {
              _CreateCaracter(payload: $payload) {
                status,
                message
              }
            }
          `,
          variables: {
            payload: {
              id: payload.prodid,
              caracter: [{ name: payload.name }]
            }
          }
        })
        .then(res => {
          if(res.data.data._CreateCaracter.status) {
            commit('PUSH_CARACTER_PROD', { name: payload.name })
            dispatch('Loading', false)
            resolve()
          }
          else {
            dispatch('Loading', false)
            dispatch('PushMsg', { msg: res.data.data._CreateCaracter.message, color: 'red' })
            resolve()
          }
        })
      }
      else {
        dispatch('Loading', false)
        commit('PUSH_CARACTER_PROD', { name: payload.name, id: Math.round(Math.random() * 1000000) })
        resolve()
      }
    })
  },
  DelCaracterProd ({ commit, dispatch, getters }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      if(getters.SelectedProdEdit.id !== '') {
        this.$http.post('', {
          query: `
            mutation ($payload: iproduto) {
              _DeleteCaracter (payload: $payload) {
                status,
                message
              }
            }
          `,
          variables: {
            payload: {
              caracter: [payload]
            }
          }
        })
        .then(res => {
          if(res.data.data._DeleteCaracter.status) {
            dispatch('Loading', false)
            commit('DEL_CARACTER_PROD', payload)
            resolve()
          }
          else {
            dispatch('Loading', false)
            dispatch('PushMsg', { msg: res.data.data._DeleteCaracter.message, color: 'red' })
            resolve()
          }
        })
      }
      else {
        dispatch('Loading', false)
        commit('DEL_CARACTER_PROD', payload)
        resolve()
      }
    })
  },
  SetIcon: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_ICON', payload)
    resolve()
  }),
  CreateProductImage ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _CreateProductImage(payload: $payload)
          }
        `,
        variables: {
          payload: {
            id: payload.prodid,
            img: [{ img: payload.img }]
          }
        }
      })
      .then((res) => {
        if(!res.data.data._CreateProductImage) {
          dispatch('PushMsg', { msg: 'Sem permissão', color: 'red' })
        }
        commit('UPDATE_ID_IMG', { id: res.data.data._CreateProductImage, img: payload.img })
        dispatch('Loading', false)
        resolve(res.data.data._CreateProductImage)
      })
    })
  },
  DeleteProductImage ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iproduto) {
            _DeleteProductImage (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            id: payload.prodid,
            img: [payload.img]
          }
        }
      })
      .then(res => {
        if(!res.data.data._DeleteProductImage.status) {
          dispatch('PushMsg', { msg: res.data.data._DeleteProductImage.message, color: 'red' })
        }
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _UpdateProduct ({ dispatch }, payload) {
    return new Promise((resolve) => {
      console.log(payload)
      dispatch('Loading', true)
      let updateItem = {
        id: payload.id,
        code: payload.code,
        tipo: payload.tipo,
        name: payload.name,
        status: payload.status,
        preco: typeof payload.preco === 'string' ? parseFloat(payload.preco.replace(/\./g, '').replace(/[^\d,]/g, '').replace(',', '.')) : payload.preco,
        oferta: typeof payload.oferta === 'string' ? parseFloat(payload.oferta.replace(/\./g, '').replace(/[^\d,]/g, '').replace(',', '.')) : payload.oferta,
        img: payload.img,
        descricao: payload.descricao,
        dateOfertaStart: payload.dateOfertaStart,
        dateOfertaEnd: payload.dateOfertaEnd,
        categoria: payload.categoria,
        gerEstoque: payload.gerEstoque,
        statusEstoque: payload.statusEstoque,
        estoque: parseInt(payload.estoque),
        exibeSemEstoque: payload.exibeSemEstoque,
        pendencia: payload.pendencia,
        visibilidade: payload.visibilidade,
        visualizacao: payload.visualizacao,
        atributos: payload.atributos,
        estoqueVariavel: [],
        caracter: payload.caracter,
        destaque: payload.destaque,
        dateCreate: payload.dateCreate
      }
      this.$http.post('', {
        query: `
          mutation ($payload: [iproduto]) {
            _UpdateProduct (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: [updateItem]
        }
      })
      .then(res => {
        console.log(res)
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._UpdateProduct.message, color: res.data.data._UpdateProduct.status ? 'green' : 'red' })
        resolve()
      })
    })
  },
  DeleteProd ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: [iproduto]) {
            _DeleteProduct (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        console.log(res)
        dispatch('Loading', false)
        if(res.data.data._DeleteProduct.status) {
          dispatch('PushMsg', { msg: res.data.data._DeleteProduct.message, color: 'green' })
          commit('DELETE_PROD', payload)
          dispatch('ClearProdEdit')
          resolve()
        }
        else {
          dispatch('PushMsg', { msg: res.data.data._DeleteProduct.message, color: 'red' })
          resolve()
        }
      })
    })
  },
  _UpdateParamMp ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: paramMp) {
            _UpdateParamMp (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', {
          msg: res.data.data._UpdateParamMp.message,
          color: !res.data.data._UpdateParamMp.status ? 'red' : 'green'
        })
        resolve()
      })
    })
  },
  _UpdateParamWa ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iwhatsapp) {
            _UpdateParamWa (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            numero: payload
          }
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', {
          msg: res.data.data._UpdateParamWa.message,
          color: res.data.data._UpdateParamWa.status ? 'green' : 'red'
        })
        commit('CHANGE_EMPRESA', { whatsapp: payload })
        resolve()
      })
    })
  },
  _UpdatePayMode ({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ipaymode) {
            _UpdatePayMode (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        commit('UPDATE_PAYMODE', payload)
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  ChangeCompany ({ commit }, payload) {
    commit('CHANGE_COMPANY', payload)
  },
  _UpdateMapsNets ({ dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: imapsnets) {
            _UpdateMapsNets (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('PushMsg', { msg: res.data.data._UpdateMapsNets.message, color: res.data.data._UpdateMapsNets.status ? 'green' : 'red' })
        resolve()
      })
    })
  },
  SearchNameProdPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: searchprodutopainel,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('GET_PRODUCT_SEARCH', res.data.data.SearchNameProdPainel)
        resolve()
      })
    })
  },
  SearchClientPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: searchclientpainel,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('GET_CLIENT', { payload: res.data.data.SearchClientPainel, init: true })
        resolve()
      })
    })
  },
  SearchPedidoPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: searchpedidopainel,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('GET_PEDIDOS', { payload: res.data.data.SearchPedidoPainel, init: true })
        resolve()
      })
    })
  },
  SearchUserPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: searchuserpainel,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        res.data.data.SearchUserPainel.map(u => {
          u.permissao = JSON.parse(u.permissao)
        })
        commit('GET_USER', { payload: res.data.data.SearchUserPainel, init: true })
        resolve()
      })
    })
  },
  SearchGiftPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: searchgiftpainel,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('GET_GIFT', { payload: res.data.data.SearchGiftPainel, init: true })
        resolve()
      })
    })
  },
  changeGiftValidate ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('CHANGE_GIFTVALIDATE', payload)
      resolve()
    })
  },
  VerifyGiftCodHas (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query($payload: String) {
            VerifyGiftCodHas (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.VerifyGiftCodHas)
      })
    })
  },
  changeFilterProdPainel ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('CHANGE_FILTER_PROD_PAINEL', payload)
      resolve()
    })
  },
  changeFrete ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('CHANGE_FRETE', payload)
      resolve()
    })
  },
  delFreteTabelaBairro ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('DEL_FRETE_TABELA_BAIRRO', payload)
      resolve()
    })
  },
  _UpdateFrete ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifrete) {
            _UpdateFrete (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: {
            tipo: payload.tipo,
            valor: parseFloat(payload.valor.replace('R$ ', '').replace(',', '.')),
            valormin: parseFloat(payload.valormin.replace('R$ ', '').replace(',', '.')),
            gratisapartir: parseFloat(payload.gratisapartir.replace('R$ ', '').replace(',', '.')),
            tokengoogleapi: payload.tokengoogleapi,
            cep: payload.cep.replace('-', '')
          }
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._UpdateFrete.message, color: 'green' })
        resolve()
      })
    })
  },
  _CreateFreteBairro ({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifretebairro) {
            _CreateFreteBairro (payload: $payload) {
              id,
              bairro,
              valor,
              valormin,
              gratisapartir
            }
          }
        `,
        variables: {
          payload: {
            bairro: payload.bairro,
            valor: parseFloat(payload.valor.replace('R$ ', '').replace(',', '.')),
            valormin: parseFloat(payload.valormin.replace('R$ ', '').replace(',', '.')),
            gratisapartir: parseFloat(payload.gratisapartir.replace('R$ ', '').replace(',', '.')),
          }
        }
      })
      .then(res => {
        commit('PUSH_FRETE_TABELA_BAIRRO', res.data.data._CreateFreteBairro)
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _DeleteFreteBairro ({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifretebairro) {
            _DeleteFreteBairro (payload: $payload) {
              id
            }
          }
        `,
        variables: {
          payload: {
            id: payload.id
          }
        }
      })
      .then(res => {
        commit('DEL_FRETE_TABELA_BAIRRO', res.data.data._DeleteFreteBairro)
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetFrete ({ dispatch, commit }) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          query {
            GetFrete {
              id,
              tipo,
              valor,
              valormin,
              gratisapartir,
              tokengoogleapi,
              cep
            }
          }
        `
      })
      .then(res => {
        commit('GET_FRETE', res.data.data.GetFrete)
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetFreteBairro ({ dispatch, commit }) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          query {
            GetFreteBairro {
              id,
              bairro,
              valor,
              valormin,
              gratisapartir
            }
          }
        `
      })
      .then(res => {
        commit('GET_FRETE_BAIRRO', res.data.data.GetFreteBairro)
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _CreateFrenteLojaSlideImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: islideimg) {
            _CreateFrenteLojaSlideImg(payload: $payload) {
              id,
              img
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data._CreateFrenteLojaSlideImg)
      })
    })
  },
  _DeleteFrenteLojaSlideImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: islideimg) {
            _DeleteFrenteLojaSlideImg (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetFrenteLojaSlideImg () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetFrenteLojaSlideImg {
              id,
              img
            }
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetFrenteLojaSlideImg)
      })
    })
  },
  _UpdateFrenteLojaSlogan ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: islogan) {
            _UpdateFrenteLojaSlogan (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetFrenteLojaSlogan () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetFrenteLojaSlogan {
              text,
              img
            }
          }
        `
      })
      .then(res => {
        if(res.data.data.GetFrenteLojaSlogan !== null) {
          resolve(res.data.data.GetFrenteLojaSlogan)
        }
        else {
          resolve({ text: '', img: '' })
        }
      })
    })
  },
  _CreateFrenteLojaCategoria ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifrentelojacategoria) {
            _CreateFrenteLojaCategoria (payload: $payload) {
              id,
              nome,
              img,
              link
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data._CreateFrenteLojaCategoria)
      })
    })
  },
  _DeleteFrenteLojaCategoria ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifrentelojacategoria) {
            _DeleteFrenteLojaCategoria (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _UpdateFrenteLojaCategoria ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ifrentelojacategoria) {
            _UpdateFrenteLojaCategoria (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetFrenteLojaCategoria () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetFrenteLojaCategoria {
              id,
              nome,
              img,
              link
            }
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetFrenteLojaCategoria)
      })
    })
  },
  GetProductNews () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetProductNews {
              id,
              code,
              tipo,
              name,
              link,
              status,
              preco,
              oferta,
              img {
                id,
                img
              },
              descricao,
              dateOfertaStart,
              dateOfertaEnd,
              categoria,
              gerEstoque,
              statusEstoque,
              estoque,
              pendencia,
              visibilidade,
              visualizacao,
              dateCreate,
              caracter {
                id,
                name
              },
              atributos {
                active,
                id,
                name,
                values {
                  active,
                  id,
                  name,
                  selected
                }
              },
              estoqueVariavel {
                id,
                src {
                  quantidade,
                  values {
                    id,
                    idParent,
                    name,
                    value
                  }
                }
              }
            }
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetProductNews)
      })
    })
  },
  GetDestaques () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetDestaques {
              id,
              code,
              tipo,
              name,
              link,
              status,
              preco,
              oferta,
              img {
                id,
                img
              },
              descricao,
              dateOfertaStart,
              dateOfertaEnd,
              categoria,
              gerEstoque,
              statusEstoque,
              estoque,
              pendencia,
              visibilidade,
              visualizacao,
              dateCreate,
              caracter {
                id,
                name
              },
              atributos {
                active,
                id,
                name,
                values {
                  active,
                  id,
                  name,
                  selected
                }
              },
              estoqueVariavel {
                id,
                src {
                  quantidade,
                  values {
                    id,
                    idParent,
                    name,
                    value
                  }
                }
              }
            }
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetDestaques)
      })
    })
  },
  _UpdateFrenteLoja ({ dispatch, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: icompany) {
            _UpdateFrenteLoja (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        commit('CHANGE_EMPRESA', { frenteloja: payload.frenteloja })
        if(payload.frenteloja) {
          router.addRoute({
            name: 'Frente de loja',
            path: '/desativado',
            component: FrenteLoja
        })
        }
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetBannerImg () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetBannerImg {
              id,
              link,
              img
            }
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetBannerImg)
      })
    })
  },
  _CreateBannerImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ibannerimg) {
            _CreateBannerImg (payload: $payload) {
              id,
              link,
              img
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data._CreateBannerImg)
      })
    })
  },
  _DeleteBannerImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ibannerimg) {
            _DeleteBannerImg (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _UpdateBannerImg ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: ibannerimg) {
            _UpdateBannerImg (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  _UpdateTagmanager ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: icompany) {
            _UpdateTagmanager (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      })
    })
  },
  GetQuantityCopy (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: String) {
            GetQuantityCopy(name: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.GetQuantityCopy)
      })
    })
  },
  GetProdutoStatus ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: Int) {
            GetProdutoStatus (status: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('GET_PRODUTO_STATUS', { status: payload, value: res.data.data.GetProdutoStatus })
        resolve()
      })
    })
  },
  _DeleteAtrValue ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: Int) {
            _DeleteAtrValue (payload: $payload) {
              status
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        if(res.data.data._DeleteAtrValue.status) {
          dispatch('Loading', false)
          commit('DELETE_ATR_VALUE', payload)
          dispatch('PushMsg', { msg: 'Valor excluído com sucesso.', color: 'green' })
          resolve()
        } else {
          dispatch('Loading', false)
          dispatch('PushMsg', { msg: 'Não foi possível excluir o valor', color: 'red' })
          resolve()
        }
      })
    })
  },
  GetPayment (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($id: String) {
            GetPayment(id: $id) {
              status,
              status_detail,
              id,
              authorization_code,
              date_created,
              date_last_updated,
              date_of_expiration,
              description,
              installments,
              payment_method_id,
              payment_type_id,
              taxes_amount,
              transaction_amount
            }
          }
        `,
        variables: {
          id: payload
        }
      })
      .then(res => {
        resolve(res.data.data.GetPayment)
      })
    })
  }
}
